var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhRows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 17.5H6C5.46957 17.5 4.96086 17.7107 4.58579 18.0858C4.21071 18.4609 4 18.9696 4 19.5V24.5C4 25.0304 4.21071 25.5391 4.58579 25.9142C4.96086 26.2893 5.46957 26.5 6 26.5H26C26.5304 26.5 27.0391 26.2893 27.4142 25.9142C27.7893 25.5391 28 25.0304 28 24.5V19.5C28 18.9696 27.7893 18.4609 27.4142 18.0858C27.0391 17.7107 26.5304 17.5 26 17.5ZM26 24.5H6V19.5H26V24.5ZM26 6.5H6C5.46957 6.5 4.96086 6.71071 4.58579 7.08579C4.21071 7.46086 4 7.96957 4 8.5V13.5C4 14.0304 4.21071 14.5391 4.58579 14.9142C4.96086 15.2893 5.46957 15.5 6 15.5H26C26.5304 15.5 27.0391 15.2893 27.4142 14.9142C27.7893 14.5391 28 14.0304 28 13.5V8.5C28 7.96957 27.7893 7.46086 27.4142 7.08579C27.0391 6.71071 26.5304 6.5 26 6.5ZM26 13.5H6V8.5H26V13.5Z",
    fill: "#393D4E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhRows);
export default __webpack_public_path__ + "static/media/ph_rows.ab65675c0f2bae7b6cf0251b22cf6b61.svg";
export { ForwardRef as ReactComponent };